import React from 'react';

function Contact() {
  return (
    <div className="p-10">
      <h1 className="text-2xl font-bold">Contact Us</h1>
      <p className="mt-4">
               Email:{' '}
        <a
          href="mailto:cidade.serena@gmail.com"
          className="text-blue-700 underline"
        >
          cidade.serena@gmail.com
        </a>{' '}
        | Phone (Cape Verde): +238 596 71 41 | Phone (USA) +1 346 837 5339
      </p>
    </div>
  );
}

export default Contact;